import type { NCNode } from '../../../../src/commonTypes';

const MAX_CONTEXT_PATH_ANCESTORS = 3;

/** Upstream labels from root toward the seed (excludes the seed node). */
export const buildNodeContextPath = (
	nodes: NCNode[],
	seedNode: NCNode,
	maxAncestors: number = MAX_CONTEXT_PATH_ANCESTORS
): string[] => {
	const path: string[] = [];
	let current: NCNode | undefined = seedNode;

	for (let depth = 0; depth < maxAncestors && current?.parent?.uid; depth += 1) {
		const parent = nodes.find((node) => node.uid === current!.parent!.uid);
		if (!parent) break;
		const label = (parent.label || '').trim();
		if (label) path.unshift(label);
		current = parent;
	}

	return path;
};
